import React, { Component, createRef, useCallback } from "react";
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Alert from 'react-bootstrap/Alert';
import InputGroup from 'react-bootstrap/InputGroup';
import Row from 'react-bootstrap/Row';
import AuthService from "../services/auth-service";
import { Navigate } from "react-router-dom";
import ReCAPTCHA from 'react-google-recaptcha';
import notify from "devextreme/ui/notify";
import LoadingSpinner from '../comp/gen/LoadingSpinner';

// ************************************************************
// ************************************************************
// ************************************************************

export const ResetPasswordWrapper = (props) => {
  const { reset_code } = useParams()
  const navigate = useNavigate()
  return <ResetPassword 
    reset_code={reset_code} 
    navigate={navigate} 
    {...props} />
}

class ResetPassword extends React.Component {
  constructor(props) {    
    super(props); 
    this.state = { 
      loading: true,
      validated: false,
      disabled: false,
      email: "",
      password: "",
      confirmPassword: "",
      successMessage: undefined,
      errorMessage: undefined,
      refreshReCaptcha: true,      
      redirectToLogin: false,
    }
    this.captchaRef = createRef()
  }
  async componentDidMount() {
    if (this.props.reset_code !== undefined) {
      console.log("reset_code", this.props.reset_code)     
      this.setState({ loading: false })
    } else {
      this.setState({ loading: false })
    }
  }



  onChangePassword(e) {
    this.setState({
      password: e.target.value
    })
  }
  onChangeConfirmPassword(e) {
    this.setState({
      confirmPassword: e.target.value
    })
  }
  onChangeEmail(e) {
    this.setState({
      email: e.target.value
    })
  }



  handleResetSubmit(e) {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      console.log("Data form not valid!")
      this.setState({ 
        validated: true,
      })
    } else {
      console.log("Data form ok")
      
      var captcha_value = this.captchaRef.current.getValue()
      //console.log("captcha_value", captcha_value)

      this.setState({ 
        loading: true,
      })
      AuthService.ResetPassword(this.state.email, captcha_value).then(data => {
        if (data.is_valid) {
          this.notifySomething("PASSWORD RESET SENT")
          this.setState({ 
            successMessage: "If you have a valid account, password recovery instructions have been sent to the registered email address.",
            errorMessage: undefined,
            loading: false,
            validated: false,
            disabled: true,
          })
        } else {
          this.notifySomething("RESET PASSWORD ERROR", "error")
          this.setState({ 
            successMessage: undefined,
            errorMessage: data.message,
            loading: false,
            validated: false,
            disabled: false,
          })
        } 
      }).catch(error => {
        this.setState({ 
          successMessage: undefined,
          errorMessage: "Unknown error",
          loading: false,
          validated: false,
          disabled: false,
        })        
      })
    }    
  }
  handleChangeSubmit(e) {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      console.log("Data form not valid!")
      this.setState({ 
        validated: true,
      })
    } else {
      console.log("Data form ok")
      
      this.setState({ 
        loading: true,
      })
      AuthService.ChangePassword(this.props.reset_code, this.state.password, this.state.confirmPassword).then(data => {
        if (data.is_valid) {
          this.notifySomething("PASSWORD CHANGED")
          this.setState({ 
            redirectToLogin: true,
            errorMessage: undefined,
            loading: false,
            validated: false,
            disabled: true,
          })
        } else {
          this.notifySomething("CHANGE PASSWORD ERROR", "error")
          this.setState({ 
            redirectToLogin: false,
            errorMessage: data.message,
            loading: false,
            validated: false,
            disabled: false,
          })
        } 
      }).catch(error => {
        this.setState({ 
          redirectToLogin: false,
          errorMessage: "Unknown error",
          loading: false,
          validated: false,
          disabled: false,
        })        
      })
    }    
  }



  // funzione per visualizzare un messaggio che poi scompare in automatico
  notifySomething(message, type="success") {
    notify({
      message: message,
      position: {
        my: 'center top',
        at: 'center top',
      },
    }, type, 3000)
  }  
  render() {    
    if (this.state.loading) return <LoadingSpinner />    
    if (this.state.redirectToLogin) return <Navigate to="/service/user/login" replace={true} />

    if (this.props.reset_code !== undefined) {
      return (
        <Form noValidate validated={this.state.validated} onSubmit={e => this.handleChangeSubmit(e)}>

          <Row style={{ marginTop: "15px" }}> 
            <Col md="4"></Col>
            <Col md="4">

              <Row className="mb-3">
                <Form.Group as={Col} controlId="validationPassword">
                  <Form.Label>Password</Form.Label>
                  <Form.Control 
                    required 
                    type="password" 
                    placeholder="Password" 
                    disabled={this.state.loading}
                    onChange={e => this.onChangePassword(e)} />
                  <Form.Control.Feedback type="invalid">
                    Please enter a password.
                  </Form.Control.Feedback>
                </Form.Group>
              </Row>

              <Row className="mb-3">
                <Form.Group as={Col} controlId="validationPassword">
                  <Form.Label>Confirm password</Form.Label>
                  <Form.Control 
                    required 
                    type="password" 
                    placeholder="Confirm password" 
                    disabled={this.state.loading}
                    onChange={e => this.onChangeConfirmPassword(e)} />
                  <Form.Control.Feedback type="invalid">
                    Please enter a password.
                  </Form.Control.Feedback>
                </Form.Group>
              </Row>

              <Row className="mb-3">
                <Col>
                  <Button type="submit">Change password</Button>
                </Col>
              </Row>

              {this.state.errorMessage && (
                <Row className="mb-3">
                  <Col>
                    <Alert key="danger" variant="danger">
                      {this.state.errorMessage}
                    </Alert>
                  </Col>  
                </Row>
              )}

            </Col>
            <Col md="4"></Col>
          </Row>
        </Form>
      )
    }

    return (
      <Form noValidate validated={this.state.validated} onSubmit={e => this.handleResetSubmit(e)}>

        <Row style={{ marginTop: "15px" }}> 
          <Col md="4"></Col>
          <Col md="4">

            <Row className="mb-3">          
              <Form.Group as={Col} controlId="validationEmail">
                <Form.Label>Email</Form.Label>
                <Form.Control 
                  required
                  type="email" 
                  placeholder="Email" 
                  disabled={this.state.disabled}
                  onChange={e => this.onChangeEmail(e)} />
                <Form.Control.Feedback type="invalid">
                  Please enter your email.
                </Form.Control.Feedback>
              </Form.Group>          
            </Row>

            {!this.state.disabled && (
              <Row className="mb-3">
                <Col>
                  <ReCAPTCHA 
                    sitekey="6Ldle-wjAAAAANonLOdezKmp6ae5YexQEu70iVsT" 
                    ref={this.captchaRef}  
                  />                 
                </Col>
              </Row>
            )}

            <Row className="mb-3">
              <Col>
                <Button disabled={this.state.disabled} type="submit">Reset password</Button>
              </Col>
            </Row>

            {this.state.errorMessage && (
              <Row className="mb-3">
                <Col>
                  <Alert key="danger" variant="danger">
                    {this.state.errorMessage}
                  </Alert>
              </Col>  
              </Row>
            )}

            {this.state.successMessage && (
              <Row className="mb-3">
                <Col>
                  <Alert key="primary" variant="primary">
                    {this.state.successMessage}
                  </Alert>
              </Col>  
              </Row>
            )}

          </Col>
          <Col md="4"></Col>
        </Row>
      </Form>
    )
  }
}
